import { useWindowWidth } from "@/hooks/dim-hook";

const mobileProductBox = 820;

export const useIsSmallScreen = () => {
  const w = useWindowWidth();
  const isSamllScreen = w <= mobileProductBox;
  return isSamllScreen;
};
